<div class="flex-control flex-column" *ngIf="practice.id">
  <ng-container *ngComponentOutlet="wizardComponent;injector: custom_injector;"></ng-container>
</div>
